import React, { useMemo } from 'react';
import Empty from '~/App/Modules/MyLibrary/Components/Empty';
import Card from '~/App/Components/Cards/Card';
import { socialsUrl } from '~/App/Modules/Socials/util';

export default function TestimonialsAllEmpty() {
  const cards = useMemo(
    () => [
      {
        //TODO: source from an .env or file the url for responses
        onClick: () => (window.location.href = '/projects'),
        icon: 'icon-projects',
        label: 'Request testimonials from customers',
      },
      {
        //TODO: source from an .env or file the url for testimonials uploads
        onClick: () => (window.location.href = '/projects/assets/uploads'),
        icon: 'icon-cloud-upload',
        label: 'Upload existing testimonials',
      },
      {
        onClick: () => (window.location.href = `${socialsUrl}/all`),
        icon: 'icon-socials',
        label: 'Add from social media channels',
      },
    ],
    []
  );

  return (
    <Empty
      title="You haven't collected any testimonials yet"
      subtitle='Request video or written testimonials from your customers, upload your existing assets or gather
    social posts to start creating your Wall of love.'
    >
      <div className='mt-12 mb-7 text-xl font-bold'> I want to</div>
      <div className='v2-text-neutral-900 flex space-x-4'>
        {cards.map((card, i) => (
          <Card
            className='flex items-center justify-center flex-col'
            onClick={card.onClick}
            key={i}
          >
            <i className={`icon ${card.icon} !w-10 !h-8 mb-6 text-center`} />
            <div className='font-bold text-base text-center w-[203px]'>
              {card.label}
            </div>
          </Card>
        ))}
      </div>
    </Empty>
  );
}
